<template>
    <v-container>
        <v-skeleton-loader v-if="! registrations" type="table-body"></v-skeleton-loader>

        <v-simple-table v-else class="elevation-1">
            <thead>
                <tr>
                    <th>
                        Nama Kelompok
                    </th>
                    <th>
                        Pembuat
                    </th>
                    <th>
                        Kontak Pembuat
                    </th>
                    <th>
                        Anggota
                    </th>
                    <th>
                        Bukti Pembayaran
                    </th>
                    <th>
                        Aksi
                    </th>
                </tr>
            </thead>

            <tbody>
                <tr
                    v-for="registration in registrations"
                    :key="registration.id"
                >
                    <td>
                        {{ registration.name }}
                    </td>
                    <td>
                        {{ registration.creator_name }}
                    </td>
                    <td>
                        {{ registration.creator_contact }}
                    </td>
                    <td>
                        <v-btn @click="showMembersDialog(registration.id)" text>
                            {{ registration.member_count }}
                            <v-icon right color="info">mdi-information-outline</v-icon>
                        </v-btn>
                    </td>
                    <td>
                        <v-btn v-if="registration.payment_proof" icon @click="showProof(registration.payment_proof)">
                            <v-icon>mdi-image</v-icon>
                        </v-btn>
                        <span v-else class="warning--text">
                            Belum Membayar
                        </span>
                    </td>
                    <td>
                        <v-btn @click="deleteConfirmation(registration.id)" icon>
                            <v-icon color="red">mdi-delete</v-icon>
                        </v-btn>

                        <template v-if="registration.payment_proof">
                            <v-btn @click="rejectConfirmation(registration.id)" icon>
                                <v-icon color="warning">mdi-close</v-icon>
                            </v-btn>
                            <v-btn @click="activateConfirmation(registration.id)" icon>
                                <v-icon color="primary">mdi-check</v-icon>
                            </v-btn>
                        </template>
                    </td>
                </tr>
            </tbody>
        </v-simple-table>

        <v-dialog v-model="proofDialog" max-width="70%">
            <v-img :src="selectedProofImageUrl"></v-img>
        </v-dialog>

        <v-dialog v-model="activationDialog" max-width="400">
            <v-card>
                <v-card-title>
                    Aktifkan kelompok?
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn @click="activationDialog = false" text>Batal</v-btn>
                    <v-btn @click="activate" color="primary" text :loading="buttonLoading">Aktifkan</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="rejectionDialog" max-width="400">
            <v-card>
                <v-card-title>
                    Tolak kelompok?
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn @click="rejectionDialog = false" text>Batal</v-btn>
                    <v-btn @click="reject" color="warning" text :loading="buttonLoading">Tolak</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="deletionDialog" max-width="400">
            <v-card>
                <v-card-title>
                    Hapus kelompok?
                </v-card-title>
                <v-card-subtitle>
                    Aksi tidak dapat dibatalkan
                </v-card-subtitle>
                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn @click="deletionDialog = false" text>Batal</v-btn>
                    <v-btn @click="deleteGroup" color="error" text :loading="buttonLoading">Hapus</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="membersDialog" max-width="400">
            <v-card :loading="! members">
                <template v-if="members">
                    <v-card-title>
                        Anggota kelompok
                    </v-card-title>
                    <v-list three-line>
                        <v-list-item
                            v-for="(member, i) in members"
                            :key="i"
                        >
                            <v-list-item-avatar color="avatar">
                                <v-icon color="white">mdi-account</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ member.name }}
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    {{ member.university }}
                                </v-list-item-subtitle>
                                <v-list-item-subtitle>
                                    ID Line / WA: {{ member.contact }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="membersDialog = false" text>Tutup</v-btn>
                    </v-card-actions>
                </template>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import assetUrl from '@/tools/assetUrl'

export default {
    data() {
        return {
            registrations: null,
            selectedGroupId: null,
            proofDialog: false,
            selectedProofImage: null,
            membersDialog: false,
            members: null,
            activationDialog: false,
            rejectionDialog: false,
            deletionDialog: false,
            buttonLoading: false,
        }
    },

    computed: {
        selectedProofImageUrl() {
            return assetUrl(this.selectedProofImage)
        }
    },

    watch: {
        membersDialog(to) {
            if (to === false) {
                this.members = null
            }
        }
    },

    methods: {
        showProof(proof) {
            this.selectedProofImage = proof
            this.proofDialog = true
        },

        showMembersDialog(group_id) {
            this.membersDialog = true
            this.$api.get(`group/${group_id}/member`)
                .then(response => {
                    this.members = response.data.members
                })
        },

        deleteConfirmation(group_id) {
            this.selectedGroupId = group_id
            this.deletionDialog = true
        },

        rejectConfirmation(group_id) {
            this.selectedGroupId = group_id
            this.rejectionDialog = true
        },

        activateConfirmation(group_id) {
            this.selectedGroupId = group_id
            this.activationDialog = true
        },

        activate() {
            this.buttonLoading = true

            this.$api.patch(`group/${this.selectedGroupId}/activate`)
                .then(response => {
                    this.buttonLoading = false

                    if (response.data.activated) {
                        this.activationDialog = false
                        this.getData()
                    }
                })
        },

        reject() {
            this.buttonLoading = true

            this.$api.patch(`group/${this.selectedGroupId}/reject`)
                .then(response => {
                    this.buttonLoading = false

                    if (response.data.rejected) {
                        this.rejectionDialog = false
                        this.getData()
                    }
                })
        },

        deleteGroup() {
            this.buttonLoading = true

            this.$api.delete(`group/${this.selectedGroupId}`)
                .then(response => {
                    this.buttonLoading = false

                    if (response.data.deleted) {
                        this.deletionDialog = false
                        this.getData()
                    }
                })
        },

        getData() {
            this.$api.get('group/registration')
                .then(response => {
                    this.registrations = response.data.registrations
                })
        }
    },

    created() {
        this.getData()
    }
}
</script>
